import URLS from '@/server/urls';
import { GET } from '@/server/http';
export default async (params, options = { showError: true }) => {
    const [ content, error, status ] = await GET(URLS.user.getLoginOptions, params, options);
    if (error) return { error, status };
    return content || {
        needVerifyCode: true, // 是否需要验证码
        allowSignFailCount: 5, // 允许登录失败次数
        signFailLockEnable: true, // 登录失败锁定开启
        signFailLockDuration: '24h', // 登录失败锁定持续时间
        pwdNeedLowercase: true, // 密码是否需要小写字母
        pwdNeedUppercase: true, // 密码是否需要大写字母
        pwdNeedDigit: true, // 密码是否需要数字
        pwdNeedSpecial: true, // 密码是否需要特殊字符
        pwdMinLen: 6, // 密码最小长度
        pwdMaxLen: 20, // 密码最大长度
        pwdDisRegular: true, // 密码是否禁用常规字符
        pwdDisCommon: true, // 密码是否禁用常用密码
        pwdDisBirthday: true, // 密码是否禁用生日日期
        pwdHistoryEnable: true, // 密码是否禁用历史密码
        pwdHistoryCount: 5, // 密码历史记录数量
        verifyLoginEnabled: false, // 是否开启验证码登录功能
        verifyCodeLifeTime: 5 * 60, // 验证码有效期，单位：秒
        wxLoginEnabled: false, // 是否开启微信登录功能
    };
};
